import { FC } from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Textarea,
} from "@altimateai/lego";
import { ScheduleFormValues } from "./useScheduleForm";

interface ScheduleEmailsFieldProps {
  control: Control<ScheduleFormValues>;
  emailsOptional: boolean;
}

const ScheduleEmailsField: FC<ScheduleEmailsFieldProps> = ({ control, emailsOptional }) => (
  <FormField
    control={control}
    name="emails"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Email Recipients{emailsOptional ? " (optional)" : ""}</FormLabel>
        <FormControl>
          <Textarea placeholder="Enter email addresses, separated by commas" rows={3} {...field} />
        </FormControl>
        <FormMessage />
        <p className="al-text-xs al-text-muted-foreground">Separate multiple emails with commas</p>
      </FormItem>
    )}
  />
);

export default ScheduleEmailsField;
